<template>
    <o-card class="widget-table-height">
        <div class="" style="margin-top: -15px;">
            <div>
                <span class="text-body text-start fs-5">
                    <slot name="card-name"></slot>
                </span>
                <div class="table-rank">
                    <table class="table table-borderless">
                        <thead class="custom-thead">
                            <slot name="table-head"></slot>
                        </thead>
                        <tbody>
                            <slot name="table-body"></slot>
                        </tbody>
                    </table>
                </div>
                <span class="text-start see-more">
                    <slot name="end-card"></slot>
                </span>
            </div>
        </div>
    </o-card>
</template>
<script>
    import { 
        OCard,
        // OTable
        } from '@/components/OmnihControl';
    export default {
    components:{
        OCard,
        // OTable
    }
}
</script>
<style>
    .widget-table-height{
        min-height: 248px;
        /* min-width: 340px !important; */
    }
    table > thead.custom-thead{
        background-color: transparent;
        border-style: none none solid;
        border-color: var(--primary-color, #F93E3E);;
        text-transform: none;
        color: var(--primary-color, #F93E3E);;
        font-size: 12px;
    }
    .see-more{
        font-size: 10px;
        color: var(--primary-color, #F93E3E);;
    }
</style>